module.exports = __webpack_public_path__ + "img/empty-message-box_liveflamingo.e2e0cf17.svg";